import { useQuery } from "@tanstack/react-query";
import { fetchService } from "../utils/api";
import { errorToast } from "../utils/toastFunc";

export const useVendorCode = () => {
  return useQuery({
    queryKey: ["vendorCodesLookUp"],
    queryFn: async () => await fetchService({ url: "/lookUp/getVendorCodes" }),
    onError: (err) => {
      errorToast(err.message);
    },
  });
};

export const useDriverVehicleDepartment = () => {
  return useQuery({
    queryKey: ["getDriverVehicleDepartmentLookup"],
    queryFn: async () =>
      await fetchService({ url: "/lookUp/getDriverVehicleDepartment" }),
    onError: (err) => {
      errorToast(err.message);
    },
  });
};
